<template>
  <div class="pay-mooney">
    <section class="pay-mooney-field">
      <div class="pay-mooney-field-title">损失金额</div>
      <z-field v-model="compensateMoney" type="digit" label="￥" placeholder="请输入您损失的金额" />
    </section>
    <div class="pay-mooney-warn">{{ moneyTip }}</div>

    <section class="pay-mooney-idcard">
      <div class="pay-mooney-idcard-upload">
        <capture-upload
          order="1"
          @uploaded="UploadedPic"
          img="n_v2c26867e9206f44009400ddde871a2593.png"
        />
        <capture-upload
          order="2"
          @uploaded="UploadedPic"
          img="n_v27754addf40324bd08c077a4ce8bbb045.png"
        />
      </div>
      <div class="pay-mooney-warn">{{ IdCardTip }}</div>
    </section>

    <section class="pay-mooney-evidence">
      <capture-upload
        @uploaded="UploadedEvi"
        type="evidence"
        img="n_v26447db98ed6840a396a328315d45f381.png"
      />
      <div class="pay-mooney-warn">{{ evidenceTip }}</div>
    </section>

    <!-- 需要注释 -->
    <!-- <p>需要注释</p>
    <p>【price】{{price}}</p>
    <p>【applySource】{{applySource}}</p>
    <p>picFront{{picFront}}</p>
    <p>picBack{{picBack}}</p> -->
    <!-- 需要注释 -->

    <z-button-group>
      <z-button
        type="primary"
        btn-class="bottombtn"
        loading-text="提交..."
        :disabled="disabled"
        :loading="loading"
        @click="submmit()"
        >提交</z-button
      >
    </z-button-group>
    </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Field, Button, ButtonGroup, Toast } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'
import { queryParams } from '../../../lib/utils'
import CaptureUpload from './CaptureUpload/CaptureUpload'
import { submitPayMoney } from '../../../api/resourceApi'

const query = queryParams()
const moneyTip =
    '*填写金额不得高于订单实付金额。追款成功将全部打入您的微信账户；如追款失败，最高赔付金额为2000元。'
const IdCardTip =
    '*身份证需与您实人认证时的信息保持一致；您提供的信息仅用于信息核查，转转保证您的信息安全不被泄露'
const evidenceTip =
    '*订单金额≥3000元时，必须提供；订单金额<3000元，会优先处理，伪造派出所回执属于违法行为，请确保上传图片真实性'

export default {
  name: 'SubmitComp',
  data() {
    return {
      toUid: query.toUid || this.$route.query.toUid,
      orderId: query.orderId || this.$route.query.orderId,
      price: query.price || this.$route.query.price,
      applySource: query.applySource || this.$route.query.applySource,
      loading: false,
      picFront: '',
      picBack: '',
      evidence: '',
      evidenceTip,
      IdCardTip,
      moneyTip,
      compensateMoney: query.price || this.$route.query.price || '',
      data: {}
    }
  },
  computed: {
    disabled() {
      return (
        this.compensateMoney === '' ||
          this.picBack === '' ||
          this.picFront === '' ||
          (+this.price >= 3000 && !this.evidence)
      )
    }
  },
  components: {
    zButtonGroup: ButtonGroup,
    zButton: Button,
    zField: Field,
    CaptureUpload
  },
  methods: {
    UploadedPic(rst, _startTime, order) {
      if (order === '1') this.picFront = rst
      if (order === '2') this.picBack = rst
      // this.pic.splice(order - 1, 1, rst)
    },
    UploadedEvi(rst, _startTime, _order) {
      this.evidence = rst
    },
    submmit() {
      if (this.compensateMoney === '') return Toast('请输入损失金额')
      if (this.picFront === '') return Toast('请上传证件人像面')
      if (this.picBack === '') return Toast('请上传证件国徽面')
      if (+this.price >= 3000 && !this.evidence) return Toast('上传派出所回执证明')
      this.submitData()
    },
    submitData() {
      lego.send({
        pagetype: 'ZZUP_PAYMONEY',
        actiontype: 'SUBMITPAGE_CLICK',
        backup: {}
      })

      this.loading = true
      const params = {
        toUid: this.toUid,
        orderId: this.orderId,
        applySource: this.applySource,
        compensateMoney: this.compensateMoney,
        cardPics: `${this.picFront}|${this.picBack}`,
        evidence: this.evidence
      }
      submitPayMoney(params)
        .then((_res) => {
          this.loading = false
          Toast('提交成功')
          const targetUrl = `https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneySuccess&orderId=${this.orderId}`
          setTimeout(() => {
            native.skipToUrl({ targetUrl, needClose: '1' })
          }, 1500)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
        })
    }
  },
  mounted() {
    native.setTitle({
      title: '放心转'
    })
    const obj = {
      label: '赔付说明',
      url: 'https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyDescription',
      newPageTitle: '赔付说明',
      needLogin: 0,
      color: '#111111'
    }
    native.wrap('setRightBtn')(obj)
    lego.send({
      pagetype: 'ZZUP_PAYMONEY',
      actiontype: 'SUBMITPAGE_SHOW',
      backup: {}
    })
  },
  destroyed() {},
  beforeRouteEnter(_to, _from, next) {
    // const obj = {
    //   label: '赔付说明',
    //   url: 'https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyDescription',
    //   newPageTitle: '赔付说明',
    //   needLogin: 0,
    //   color: '#111111'
    // };
    next((_vm) => {
      // native.wrap('setRightBtn')(obj)
    })
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
